import styled from 'styled-components';

const Container = styled.div`
  max-width: ${({ theme }) => theme.containerWidth}px;
  margin: 0 auto;
`;

export default Container;
